import { inject, Service } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { StorageService } from '@app/shared';

import { I18nHtmlLangService } from './html-lang.service';

@Service()
export class LanguageService {
    private translateService = inject(TranslateService);
    private storageService = inject(StorageService);
    private i18nHtmlLangService = inject(I18nHtmlLangService);

    readonly language$ = new BehaviorSubject<string>('');
    readonly changed$ = new Subject<string>();

    init() {
        this.translateService.addLangs(environment.languages.supported.map((lang) => lang.key));
        this.translateService.setFallbackLang(environment.languages.default);
        const lang = this.storageService.getItem<string>('language');
        if (lang && environment.languages.supported.map((lang) => lang.key).includes(lang)) {
            this.translateService.use(lang);
            this.language$.next(lang);
            this.changed$.next(this.get());
        } else {
            this.language$.next(this.get());
            this.changed$.next(this.get());
        }
    }

    set(lang: string): void {
        this.translateService.use(lang);
        this.i18nHtmlLangService.setLang(lang);
        this.storageService.setItem('language', lang);
        this.language$.next(lang);
        this.changed$.next(this.get());
    }

    get(): string {
        if (!this.translateService.getCurrentLang()) {
            this.translateService.use(environment.languages.default);
        }
        return this.translateService.getCurrentLang() ?? environment.languages.default;
    }
}
